var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnboarding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 140,
    viewBox: "0 0 158 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M147.399 75.6209C140.202 87.0005 131.021 96.9669 121.797 106.782C112.69 116.473 103.255 126.229 91.4459 132.335C77.2258 139.696 60.5247 141.135 44.6297 139.261C25.9187 137.053 3.4346 130.41 1.63086 107.978C1.19649 102.546 2.29714 97.1177 2.60635 91.6782C3.55607 75.205 -7.29948 55.8207 9.36484 43.8338C18.597 37.2092 31.7938 37.5331 40.2308 29.9185C46.555 24.2103 48.8814 15.1346 54.9294 9.13563C59.159 4.95845 64.9347 2.592 70.795 1.49158C78.5253 0.0415245 86.4028 0.755509 94.203 0.350673C102.471 -0.0652054 110.834 -0.385395 119.017 1.13458C125.235 2.29407 131.192 4.56698 136.602 7.84384C139.898 9.84444 142.935 12.2424 145.646 14.9837C152.769 22.2229 157.404 31.9979 157.945 42.1298C158.582 54.0137 153.752 65.5662 147.399 75.6209Z",
    fill: "#2E89E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7483 115.335C30.2071 115.162 26.018 115.272 23.9786 118.165C25.2597 119.758 27.2916 120.52 29.2757 121.061C34.7532 122.563 40.4663 122.931 46.1352 123.292C52.7906 123.718 59.6816 124.109 65.9211 121.753C67.0696 121.319 68.2917 120.682 68.704 119.527C66.753 117.793 63.948 117.502 61.3418 117.296C52.2016 116.571 42.9216 115.335 33.7483 115.335Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9732 119.357C45.9732 120.093 46.0211 120.943 46.5843 121.432C46.9366 121.694 47.3545 121.853 47.7917 121.892C49.6669 122.171 51.5828 121.908 53.3133 121.134C53.452 121.089 53.5713 120.998 53.652 120.877C53.6869 120.789 53.7019 120.695 53.6962 120.601C53.6795 120.127 53.4926 119.675 53.1698 119.327C52.6864 118.89 52.1021 118.579 51.4691 118.422L48.7708 117.528C48.0346 117.277 47.118 117.049 46.345 117.307C45.9254 117.447 45.9769 117.263 45.9548 117.851C45.9438 118.348 45.9732 118.856 45.9732 119.357Z",
    fill: "#2E2E3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9732 119.357C45.9732 120.093 46.0211 120.943 46.5843 121.432C46.9366 121.694 47.3545 121.853 47.7917 121.892C49.6669 122.171 51.5828 121.908 53.3133 121.134C53.452 121.089 53.5713 120.998 53.652 120.877C53.6869 120.789 53.7019 120.695 53.6962 120.601C53.6795 120.127 53.4926 119.675 53.1698 119.327C52.6864 118.89 52.1021 118.579 51.4691 118.422L48.7708 117.528C48.0346 117.277 47.118 117.049 46.345 117.307C45.9254 117.447 45.9769 117.263 45.9548 117.851C45.9438 118.348 45.9732 118.856 45.9732 119.357Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3484 83.8745C37.9595 93.8334 38.5852 103.932 36.5349 113.685C36.3657 114.306 36.2961 114.949 36.3287 115.592C36.3488 115.913 36.4493 116.224 36.6211 116.496C36.7928 116.768 37.0303 116.992 37.3116 117.148C37.6599 117.278 38.039 117.303 38.4011 117.218C38.7632 117.134 39.0924 116.944 39.3472 116.674C39.849 116.124 40.2257 115.472 40.4516 114.763C41.8909 111.039 42.7891 107.127 43.632 103.222C44.7118 98.2143 45.7094 93.1845 46.6248 88.1326C47.3315 84.2241 47.9904 80.2346 47.4825 76.293L41.4491 76.9076C39.9767 77.0548 37.9521 77.3713 37.3116 78.9686C36.7705 80.3009 37.2637 82.498 37.3484 83.8745Z",
    fill: "#2E2E3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3484 83.8745C37.9595 93.8334 38.5852 103.932 36.5349 113.685C36.3657 114.306 36.2961 114.949 36.3287 115.592C36.3488 115.913 36.4493 116.224 36.6211 116.496C36.7928 116.768 37.0303 116.992 37.3116 117.148C37.6599 117.278 38.039 117.303 38.4011 117.218C38.7632 117.134 39.0924 116.944 39.3472 116.674C39.849 116.124 40.2257 115.472 40.4516 114.763C41.8909 111.039 42.7891 107.127 43.632 103.222C44.7118 98.2143 45.7094 93.1845 46.6248 88.1326C47.3315 84.2241 47.9904 80.2346 47.4825 76.293L41.4491 76.9076C39.9767 77.0548 37.9521 77.3713 37.3116 78.9686C36.7705 80.3009 37.2637 82.498 37.3484 83.8745Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.071 118.059C36.0377 118.527 36.1565 118.995 36.4097 119.391C36.6125 119.62 36.864 119.801 37.1459 119.921C38.5634 120.593 40.1645 120.773 41.6958 120.432C42.1188 120.354 42.5196 120.185 42.87 119.936C43.043 119.808 43.1832 119.642 43.2792 119.45C43.3752 119.258 43.4242 119.046 43.4222 118.831C43.3964 118.628 43.3283 118.432 43.2225 118.257C43.1166 118.081 42.9753 117.93 42.8074 117.812C42.4706 117.581 42.1103 117.386 41.7326 117.23C40.3485 116.572 39.1558 115.122 37.6097 114.908C35.9275 114.684 36.0453 116.936 36.071 118.059Z",
    fill: "#2E2E3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.071 118.059C36.0377 118.527 36.1565 118.995 36.4097 119.391C36.6125 119.62 36.864 119.801 37.1459 119.921C38.5634 120.593 40.1645 120.773 41.6958 120.432C42.1188 120.354 42.5196 120.185 42.87 119.936C43.043 119.808 43.1832 119.642 43.2792 119.45C43.3752 119.258 43.4242 119.046 43.4222 118.831C43.3964 118.628 43.3283 118.432 43.2225 118.257C43.1166 118.081 42.9753 117.93 42.8074 117.812C42.4706 117.581 42.1103 117.386 41.7326 117.23C40.3485 116.572 39.1558 115.122 37.6097 114.908C35.9275 114.684 36.0453 116.936 36.071 118.059Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8692 91.9866C53.8199 94.7474 53.5949 97.5021 53.1955 100.234C52.8274 102.623 52.2385 104.975 51.6568 107.319L49.1795 117.399C49.1434 117.66 49.0247 117.903 48.8408 118.091C48.6818 118.203 48.4991 118.276 48.307 118.305L46.9414 118.607C46.7639 118.663 46.5743 118.671 46.3929 118.629C46.0027 118.492 45.9254 117.988 45.918 117.576C45.7744 110.583 46.2567 103.569 45.8297 96.5981C45.5352 91.7916 44.8137 87.0292 44.3793 82.2227C44.2615 80.9051 44.1805 79.4993 44.8137 78.3363C45.5499 76.993 47.0223 76.3378 48.388 75.8668C49.4924 75.4987 51.6164 74.4609 52.717 75.2448C53.8176 76.0287 53.6152 78.0639 53.6814 79.1717C53.8066 81.191 53.8876 83.2115 53.9244 85.2332C53.9514 87.4807 53.933 89.7318 53.8692 91.9866Z",
    fill: "#2E2E3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8692 91.9866C53.8199 94.7474 53.5949 97.5021 53.1955 100.234C52.8274 102.623 52.2385 104.975 51.6568 107.319L49.1795 117.399C49.1434 117.66 49.0247 117.903 48.8408 118.091C48.6818 118.203 48.4991 118.276 48.307 118.305L46.9414 118.607C46.7639 118.663 46.5743 118.671 46.3929 118.629C46.0027 118.492 45.9254 117.988 45.918 117.576C45.7744 110.583 46.2567 103.569 45.8297 96.5981C45.5352 91.7916 44.8137 87.0292 44.3793 82.2227C44.2615 80.9051 44.1805 79.4993 44.8137 78.3363C45.5499 76.993 47.0223 76.3378 48.388 75.8668C49.4924 75.4987 51.6164 74.4609 52.717 75.2448C53.8176 76.0287 53.6152 78.0639 53.6814 79.1717C53.8066 81.191 53.8876 83.2115 53.9244 85.2332C53.9514 87.4807 53.933 89.7318 53.8692 91.9866Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7758 39.4191C49.8236 39.9932 49.8715 40.6263 50.2727 41.0421C50.5341 41.3145 50.9427 41.4985 51.0089 41.8702C51.0752 42.2419 50.7328 42.6063 50.5341 42.9375C50.0813 43.7288 50.4089 44.7777 50.0334 45.5984C49.7941 46.0651 49.4053 46.4383 48.9291 46.6583C48.4533 46.88 47.961 47.0646 47.4567 47.2104C46.988 47.3187 46.5731 47.59 46.2861 47.9759C45.8296 48.7524 46.4591 49.8161 46.0873 50.6331C45.8002 51.2735 45.0235 51.5201 44.3277 51.6268C43.9637 51.7038 43.5875 51.7038 43.2234 51.6268C42.9562 51.5414 42.7095 51.4019 42.4986 51.217C42.2877 51.0321 42.1172 50.8058 41.9976 50.5521C41.7613 50.0433 41.606 49.5006 41.5375 48.9438C41.2283 47.1441 41.0589 45.3187 40.9154 43.4969C40.8344 42.4664 40.7681 41.3807 41.2209 40.4533C41.5597 39.8355 42.0281 39.2982 42.5939 38.8781C43.2142 38.3227 43.9514 37.9139 44.7511 37.682C45.4719 37.5519 46.2091 37.5395 46.934 37.6452L48.1524 37.7593C48.4633 37.7413 48.7753 37.7648 49.08 37.8292C49.6506 38.0537 49.7353 38.9407 49.7758 39.4191Z",
    fill: "#98646A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3782 38.3346C49.314 38.4571 49.2279 38.5669 49.1242 38.6585C47.7953 39.9576 45.756 40.2631 44.3388 41.4592C44.2456 41.529 44.1658 41.615 44.1032 41.7132C44.0176 41.9124 43.9883 42.1314 44.0185 42.3462C44.0375 42.908 43.9993 43.4703 43.9044 44.0244C43.7519 43.8528 43.6567 43.638 43.632 43.4098C43.5731 43.1853 43.4406 42.9424 43.2124 42.9203C43.1291 42.9195 43.0473 42.9427 42.9768 42.9871C42.9064 43.0314 42.8501 43.0951 42.8148 43.1706C42.7437 43.3203 42.7049 43.4833 42.7007 43.649C42.6436 43.9864 42.6436 44.331 42.7007 44.6685C42.7317 44.8395 42.8052 45 42.9146 45.135C43.024 45.2701 43.1656 45.3755 43.3265 45.4413C43.3744 45.4485 43.4178 45.4734 43.448 45.5113C43.4958 45.5886 43.4075 45.6769 43.3302 45.7284L41.2761 47.0423C41.2022 47.0981 41.1143 47.1325 41.0221 47.1417C40.8638 47.1417 40.7534 46.9871 40.654 46.8546C40.1281 46.0934 39.7036 45.267 39.3914 44.3961C39.2221 43.8441 39.1411 43.2699 38.9791 42.7179C38.8613 42.3131 38.6994 41.9229 38.611 41.5071C38.549 41.1425 38.5317 40.7717 38.5595 40.403C38.5809 39.9916 38.63 39.5821 38.7067 39.1774C38.861 38.233 39.2397 37.3395 39.811 36.5717C40.2475 36.0484 40.7873 35.6208 41.3966 35.3156C42.006 35.0104 42.6717 34.8341 43.3523 34.7978C44.7207 34.7351 46.0738 35.1075 47.2174 35.8614C47.9426 36.2847 49.9488 37.1532 49.3782 38.3346Z",
    fill: "#3D3D54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3782 38.3346C49.314 38.4571 49.2279 38.5669 49.1242 38.6585C47.7953 39.9576 45.756 40.2631 44.3388 41.4592C44.2456 41.529 44.1658 41.615 44.1032 41.7132C44.0176 41.9124 43.9883 42.1314 44.0185 42.3462C44.0375 42.908 43.9993 43.4703 43.9044 44.0244C43.7519 43.8528 43.6567 43.638 43.632 43.4098C43.5731 43.1853 43.4406 42.9424 43.2124 42.9203C43.1291 42.9195 43.0473 42.9427 42.9768 42.9871C42.9064 43.0314 42.8501 43.0951 42.8148 43.1706C42.7437 43.3203 42.7049 43.4833 42.7007 43.649C42.6436 43.9864 42.6436 44.331 42.7007 44.6685C42.7317 44.8395 42.8052 45 42.9146 45.135C43.024 45.2701 43.1656 45.3755 43.3265 45.4413C43.3744 45.4485 43.4178 45.4734 43.448 45.5113C43.4958 45.5886 43.4075 45.6769 43.3302 45.7284L41.2761 47.0423C41.2022 47.0981 41.1143 47.1325 41.0221 47.1417C40.8638 47.1417 40.7534 46.9871 40.654 46.8546C40.1281 46.0934 39.7036 45.267 39.3914 44.3961C39.2221 43.8441 39.1411 43.2699 38.9791 42.7179C38.8613 42.3131 38.6994 41.9229 38.611 41.5071C38.549 41.1425 38.5317 40.7717 38.5595 40.403C38.5809 39.9916 38.63 39.5821 38.7067 39.1774C38.861 38.233 39.2397 37.3395 39.811 36.5717C40.2475 36.0484 40.7873 35.6208 41.3966 35.3156C42.006 35.0104 42.6717 34.8341 43.3523 34.7978C44.7207 34.7351 46.0738 35.1075 47.2174 35.8614C47.9426 36.2847 49.9488 37.1532 49.3782 38.3346Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.326 42.6188C66.6984 42.1205 67.1512 41.6877 67.6659 41.3381C68.1846 40.9857 68.8148 40.8364 69.4365 40.9185C69.304 41.6546 68.4168 41.9785 68.0634 42.6336C68.0262 42.6935 68.0047 42.7618 68.0009 42.8323C68.0252 42.9677 68.1019 43.088 68.2144 43.1672C68.6204 43.5095 68.9598 43.9237 69.2156 44.3891C69.3433 44.6212 69.4239 44.8763 69.453 45.1396C69.482 45.4029 69.4589 45.6694 69.385 45.9238C69.1249 46.5152 68.6594 46.9925 68.0745 47.2671C67.4951 47.5367 66.9511 47.8766 66.4548 48.2792C66.1603 48.5626 65.8658 48.9416 65.4609 48.9196C65.3397 48.9047 65.2238 48.8609 65.1232 48.7917C65.0226 48.7225 64.9402 48.63 64.883 48.5221C64.7712 48.3075 64.7059 48.0717 64.6915 47.8302C64.5986 46.8963 64.6955 45.9532 64.9764 45.0576C65.2573 44.1621 65.7163 43.3325 66.326 42.6188Z",
    fill: "#98646A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3052 49.7474C66.8651 51.8922 66.1031 53.9582 65.045 55.8752C64.7045 56.5427 64.2762 57.1616 63.7713 57.7153C62.6044 58.9114 60.9 59.4598 59.2288 59.5555C57.5576 59.6512 53.9207 59.596 52.2826 59.2795C52.2826 59.3899 52.2826 59.4966 52.2826 59.6107C52.2568 65.3925 55.7944 75.8851 53.3869 77.9756C53.1661 78.1706 51.4544 78.4835 49.2641 78.8331C46.1241 79.3373 42.0087 79.9114 39.881 80.3052C39.1448 80.4451 38.2392 80.5371 37.7276 79.9777C37.6871 79.9335 37.6539 79.8857 37.6171 79.8378C37.3935 79.3885 37.268 78.8967 37.249 78.3951C37.0686 77.1733 36.4613 76.0728 36.0158 74.9246C34.6023 71.2847 34.7974 67.24 34.0612 63.4051C33.7851 61.9514 33.3728 60.5271 33.1704 59.0623C32.987 57.6627 32.9561 56.2473 33.0783 54.841C33.1924 53.3688 33.6268 51.6796 34.9925 51.1606L35.0477 51.1386C35.4563 51.0024 35.9238 50.9509 36.2073 50.6233C36.5754 50.2148 36.4502 49.5928 36.5754 49.0665C36.5754 49.0187 36.6011 48.9745 36.6159 48.9267C36.9214 48.0434 37.9779 47.5502 38.9276 47.6054C39.7779 47.657 40.4221 48.0655 41.1841 48.3857C41.7952 48.6433 42.3731 48.555 43.0246 48.5844C44.6995 48.6691 45.4652 48.4482 46.9708 49.2432C47.1916 49.361 46.9192 50.4945 47.1328 50.6307C47.7291 50.9987 49.7353 50.8846 50.3427 51.249C51.7406 52.0344 53.2426 52.618 54.8042 52.9824C56.03 53.3063 57.3809 53.586 58.5368 53.0781C59.5491 52.6328 60.2227 51.6833 60.8485 50.7742C61.6804 49.556 62.5161 48.3452 63.348 47.1307C63.5725 46.8031 63.8597 46.4388 64.2572 46.4277C64.4976 46.4479 64.7279 46.5332 64.9235 46.6743L66.326 47.5282C66.6945 47.7093 67.0074 47.9865 67.2315 48.3305C67.4155 48.7809 67.4415 49.2803 67.3052 49.7474Z",
    fill: "#2E89E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6097 79.8264C37.3492 79.6848 37.1151 79.4993 36.9177 79.2781C36.2956 78.5862 35.9532 77.6808 35.3532 76.9631C34.9483 76.4737 34.4329 76.0799 34.0685 75.5609C33.7437 75.0593 33.5013 74.5089 33.3507 73.9305C31.7568 68.6566 31.4623 63.0809 31.396 57.5678C31.327 56.4952 31.4339 55.4186 31.7126 54.3806C31.9536 53.6598 32.3522 53.0017 32.8794 52.4542C33.4066 51.9067 34.0493 51.4836 34.7605 51.2155C34.8477 51.1801 34.9376 51.1518 35.0293 51.1309L34.9741 51.1529C33.6084 51.6682 33.174 53.3611 33.0599 54.8333C32.9423 56.2413 32.9781 57.658 33.1666 59.0583C33.3691 60.5304 33.7814 61.9474 34.0575 63.4011C34.7937 67.236 34.5986 71.2807 36.0121 74.9206C36.4575 76.0688 37.0649 77.1692 37.2453 78.3911C37.2642 78.8899 37.3884 79.379 37.6097 79.8264Z",
    fill: "#2E89E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6097 79.8264C37.3492 79.6848 37.1151 79.4993 36.9177 79.2781C36.2956 78.5862 35.9532 77.6808 35.3532 76.9631C34.9483 76.4737 34.4329 76.0799 34.0685 75.5609C33.7437 75.0593 33.5013 74.5089 33.3507 73.9305C31.7568 68.6566 31.4623 63.0809 31.396 57.5678C31.327 56.4952 31.4339 55.4186 31.7126 54.3806C31.9536 53.6598 32.3522 53.0017 32.8794 52.4542C33.4066 51.9067 34.0493 51.4836 34.7605 51.2155C34.8477 51.1801 34.9376 51.1518 35.0293 51.1309L34.9741 51.1529C33.6084 51.6682 33.174 53.3611 33.0599 54.8333C32.9423 56.2413 32.9781 57.658 33.1666 59.0583C33.3691 60.5304 33.7814 61.9474 34.0575 63.4011C34.7937 67.236 34.5986 71.2807 36.0121 74.9206C36.4575 76.0688 37.0649 77.1692 37.2453 78.3911C37.2642 78.8899 37.3884 79.379 37.6097 79.8264Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3806 55.4339C45.1671 57.1011 44.4934 58.6726 44.0039 60.2846C42.1633 66.4087 42.9768 73.2872 40.0577 78.977C39.9102 79.3168 39.6859 79.6179 39.4025 79.8566C39.132 80.0233 38.8195 80.1092 38.5018 80.104C38.1842 80.0987 37.8746 80.0027 37.6098 79.8272C37.3862 79.3778 37.2607 78.886 37.2417 78.3845C37.0613 77.1626 36.4539 76.0622 36.0085 74.9139C34.595 71.2741 34.7901 67.2294 34.0539 63.3945C33.7778 61.9407 33.3655 60.5164 33.163 59.0517C32.9797 57.652 32.9488 56.2366 33.071 54.8303C33.1851 53.3582 33.6195 51.6689 34.9852 51.15L35.0404 51.1279C35.449 50.9917 35.9165 50.9402 36.1999 50.6127C36.568 50.2041 36.4429 49.5822 36.568 49.0559C36.568 49.008 36.5938 48.9639 36.6085 48.916C36.4944 50.3477 35.9091 52.6516 35.8723 53.1594C35.8281 54.2635 36.8331 55.1836 37.908 55.4155C38.9828 55.6474 40.0945 55.3529 41.1436 55.0143C42.8368 54.5243 44.3822 53.6228 45.6419 52.3903C45.8334 53.2551 45.4984 54.5285 45.3806 55.4339Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3796 77.9529C53.1587 78.148 51.447 78.4608 49.2567 78.8105C49.4224 77.6143 50.0408 76.5139 50.3979 75.3546C50.95 73.5549 50.869 71.6228 50.6666 69.7495C50.269 66.128 49.4371 62.5691 48.9033 58.9661C48.8702 58.7563 51.3807 59.3341 52.2826 59.2568C52.2568 65.0386 55.8054 75.8625 53.3796 77.9529Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.398 75.6208C140.202 87.0004 131.021 96.9668 121.796 106.782H82.1657C80.6253 106.783 79.0998 106.48 77.6765 105.891C76.2532 105.302 74.9599 104.438 73.8704 103.349C72.781 102.26 71.9168 100.968 71.3272 99.5447C70.7376 98.1219 70.4341 96.5968 70.4341 95.0567V19.5693C70.4341 18.0292 70.7376 16.5041 71.3272 15.0813C71.9168 13.6584 72.781 12.3657 73.8704 11.2768C74.9599 10.1879 76.2532 9.3243 77.6765 8.73525C79.0998 8.1462 80.6253 7.84327 82.1657 7.84375H136.602C139.898 9.84435 142.935 12.2423 145.646 14.9836C152.769 22.2228 157.404 31.9978 157.945 42.1298C158.582 54.0136 153.752 65.5662 147.398 75.6208Z",
    fill: "#2E89E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.687 49.3285C157.505 50.8006 157.26 52.2519 156.951 53.6823C155.254 61.4295 151.676 68.8637 147.406 75.6135C141.667 84.6855 134.669 92.8632 127.395 100.776C125.547 102.788 123.684 104.787 121.804 106.775H82.1657C80.6253 106.775 79.0998 106.472 77.6765 105.883C76.2532 105.294 74.9599 104.431 73.8704 103.342C72.781 102.253 71.9168 100.96 71.3272 99.5374C70.7376 98.1145 70.4341 96.5895 70.4341 95.0493V19.5693C70.4341 18.0292 70.7376 16.5041 71.3272 15.0813C71.9168 13.6584 72.781 12.3657 73.8704 11.2768C74.9599 10.1879 76.2532 9.3243 77.6765 8.73525C79.0998 8.1462 80.6253 7.84327 82.1657 7.84375H136.602C139.898 9.84435 142.935 12.2423 145.646 14.9836C149.988 19.3939 153.346 24.6731 155.501 30.4741C156.896 34.2146 157.72 38.1439 157.945 42.1298C158.07 44.5323 157.984 46.9411 157.687 49.3285Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.687 49.327H86.6862V30.4727H155.501C156.896 34.2131 157.72 38.1424 157.945 42.1283C158.07 44.5308 157.984 46.9396 157.687 49.327Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2755 24.5078H78.8675C76.8101 24.5078 75.1422 26.1753 75.1422 28.2323V34.8385C75.1422 36.8955 76.8101 38.563 78.8675 38.563H99.2755C101.333 38.563 103.001 36.8955 103.001 34.8385V28.2323C103.001 26.1753 101.333 24.5078 99.2755 24.5078Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.944 53.6807C155.247 61.4278 151.669 68.8621 147.398 75.6119C141.66 84.6839 134.662 92.8616 127.388 100.774H86.6862V53.666L156.944 53.6807Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.629 14.416L71.2072 21.3792L72.3667 20.5106L68.5973 11.7109L64.629 14.416Z",
    fill: "#2E89E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4625 9.09707L77.1079 18.9604L78.6577 18.8647L79.8172 8.22852L75.4625 9.09707Z",
    fill: "#2E89E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.473 22.9277L69.8525 24.7642V26.9872L60.0828 27.0865L60.473 22.9277Z",
    fill: "#2E89E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3405 24.5078H77.9325C75.8751 24.5078 74.2072 26.1753 74.2072 28.2323V34.8385C74.2072 36.8955 75.8751 38.563 77.9325 38.563H98.3405C100.398 38.563 102.066 36.8955 102.066 34.8385V28.2323C102.066 26.1753 100.398 24.5078 98.3405 24.5078Z",
    fill: "#2E89E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7589 24.5078H77.3509C75.2935 24.5078 73.6256 26.1753 73.6256 28.2323V34.8385C73.6256 36.8955 75.2935 38.563 77.3509 38.563H97.7589C99.8163 38.563 101.484 36.8955 101.484 34.8385V28.2323C101.484 26.1753 99.8163 24.5078 97.7589 24.5078Z",
    fill: "url(#paint13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.066 27.8457H74.2072V35.4051H102.066V27.8457Z",
    fill: "url(#paint14_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5548 32.7266L86.1045 32.8259L89.3917 45.5893L90.8421 45.4936L93.9379 42.3985L97.711 50.2339L99.1613 50.1346L102.449 48.0073L96.0655 41.0441L100.516 38.5305L87.5548 32.7266Z",
    fill: "url(#paint15_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 35L92.2872 47.7634L95.383 44.6682L100.606 52.408L103.894 50.2771L97.5107 43.3139L101.961 40.8002L89 35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9375 34L81.6016 32.4727L81.1484 30.543H81.1211L80.3242 34H79.043L77.8008 29.6328H78.9883L79.4922 31.5664C79.5729 31.9128 79.6549 32.3906 79.7383 33H79.7617C79.7721 32.8021 79.8177 32.4883 79.8984 32.0586L79.9609 31.7266L80.5 29.6328H81.8125L82.3242 31.7266C82.3346 31.7839 82.3503 31.8685 82.3711 31.9805C82.3945 32.0924 82.4167 32.2122 82.4375 32.3398C82.4583 32.4648 82.4766 32.5885 82.4922 32.7109C82.5104 32.8307 82.5208 32.9271 82.5234 33H82.5469C82.5703 32.8125 82.612 32.556 82.6719 32.2305C82.7318 31.9023 82.7747 31.681 82.8008 31.5664L83.3242 29.6328H84.4922L83.2344 34H81.9375ZM88.7891 34L88.4531 32.4727L88 30.543H87.9727L87.1758 34H85.8945L84.6523 29.6328H85.8398L86.3438 31.5664C86.4245 31.9128 86.5065 32.3906 86.5898 33H86.6133C86.6237 32.8021 86.6693 32.4883 86.75 32.0586L86.8125 31.7266L87.3516 29.6328H88.6641L89.1758 31.7266C89.1862 31.7839 89.2018 31.8685 89.2227 31.9805C89.2461 32.0924 89.2682 32.2122 89.2891 32.3398C89.3099 32.4648 89.3281 32.5885 89.3438 32.7109C89.362 32.8307 89.3724 32.9271 89.375 33H89.3984C89.4219 32.8125 89.4635 32.556 89.5234 32.2305C89.5833 31.9023 89.6263 31.681 89.6523 31.5664L90.1758 29.6328H91.3438L90.0859 34H88.7891ZM95.6406 34L95.3047 32.4727L94.8516 30.543H94.8242L94.0273 34H92.7461L91.5039 29.6328H92.6914L93.1953 31.5664C93.276 31.9128 93.3581 32.3906 93.4414 33H93.4648C93.4753 32.8021 93.5208 32.4883 93.6016 32.0586L93.6641 31.7266L94.2031 29.6328H95.5156L96.0273 31.7266C96.0378 31.7839 96.0534 31.8685 96.0742 31.9805C96.0977 32.0924 96.1198 32.2122 96.1406 32.3398C96.1615 32.4648 96.1797 32.5885 96.1953 32.7109C96.2135 32.8307 96.224 32.9271 96.2266 33H96.25C96.2734 32.8125 96.3151 32.556 96.375 32.2305C96.4349 31.9023 96.4779 31.681 96.5039 31.5664L97.0273 29.6328H98.1953L96.9375 34H95.6406Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 54.9698,
    y1: 100.816,
    x2: 32.3017,
    y2: 148.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 49.75,
    y1: 119.452,
    x2: 48.4952,
    y2: 123.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 51.8887,
    y1: 94.9302,
    x2: 30.7374,
    y2: 98.6709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 917.857,
    y1: 1905.7,
    x2: 900.432,
    y2: 1997.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 1512.43,
    y1: 11911,
    x2: 1181.25,
    y2: 11908.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 1335.45,
    y1: 1493.28,
    x2: 1619.93,
    y2: 1525.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 728.155,
    y1: 5376.74,
    x2: 619.96,
    y2: 5376.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 1229.02,
    y1: 3660.51,
    x2: 2466.75,
    y2: 4976.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 1081.35,
    y1: 4511.22,
    x2: 409.497,
    y2: 4402.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 25.3112,
    y1: -41.0679,
    x2: 149.864,
    y2: 106.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "white",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 15596.8,
    y1: 2216.64,
    x2: 29413.3,
    y2: 2216.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "white",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 5761.91,
    y1: 1228.76,
    x2: 7869.96,
    y2: 1228.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 13892.3,
    y1: 10293.6,
    x2: 27302.3,
    y2: 10293.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "white",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 6699.78,
    y1: 1610.5,
    x2: 6699.78,
    y2: 1009.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 6892.86,
    y1: 1170.9,
    x2: 6874.06,
    y2: 323.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 4704.45,
    y1: 1539.59,
    x2: 3079.2,
    y2: 2901.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 158,
    height: 140,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboarding);
export default __webpack_public_path__ + "static/media/onboarding.275165d2a55aefae3d185577cf91c49d.svg";
export { ForwardRef as ReactComponent };